import React, { Component } from 'react';

const ExampleTables = () =>
  <section id="tables">
    <h3 className="section-header">Tables</h3>
    <div className="row">
      <div className="columns small-16">
        <table className="table table-default">
          <thead>
            <tr>
              <td width="50%">Project</td>
              <td>Time Left</td>
              <td>Award</td>
              <td>Entries</td>
              <td>Feedback</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="project-name"><a href="#">Sweet logo for an Ice Cream Shop</a></td>
              <td>48 hrs</td>
              <td>$300</td>
              <td>52</td>
              <td><i className="fa fa-smile-o"></i></td>
            </tr>
            <tr>
              <td className="project-name"><a href="#">Sweet logo for an Ice Cream Shop</a></td>
              <td>48 hrs</td>
              <td>$300</td>
              <td>52</td>
              <td><i className="fa fa-smile-o"></i></td>
            </tr>
            <tr>
              <td className="project-name"><a href="#">Sweet logo for an Ice Cream Shop</a></td>
              <td>48 hrs</td>
              <td>$300</td>
              <td>52</td>
              <td><i className="fa fa-smile-o"></i></td>
            </tr>
            <tr>
              <td className="project-name"><a href="#">Sweet logo for an Ice Cream Shop</a></td>
              <td>48 hrs</td>
              <td>$300</td>
              <td>52</td>
              <td><i className="fa fa-smile-o"></i></td>
            </tr>
            <tr>
              <td className="project-name"><a href="#">Sweet logo for an Ice Cream Shop</a></td>
              <td>48 hrs</td>
              <td>$300</td>
              <td>52</td>
              <td><i className="fa fa-smile-o"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>;

export { ExampleTables }



// WEBPACK FOOTER //
// ./styleguide/components/tables.jsx